import mapValues from 'lodash/mapValues'
import isNil from 'lodash/isNil'

export default function csvElementFields(document, text, elements, matches) {
  return mapValues({
    [this.$i18n.t('result.context.header.document.filename')]: document.filename,
    [this.$i18n.t('result.context.header.document.task_title')]: document.task_title,
    [this.$i18n.t('result.context.header.document.medium')]: document.medium,
    [this.$i18n.t('result.context.header.document.sex')]: document.sex,
    [this.$i18n.t('result.context.header.document.age')]: document.age,
    [this.$i18n.t('result.context.header.document.native_language')]: document.native_language,
    [this.$i18n.t('result.context.header.document.placement_test_percentage_score')]: document.placement_test_percentage_score,
    [this.$i18n.t('result.context.header.document.age_studying_was_started')]: document.age_studying_was_started,
    [this.$i18n.t('result.context.header.document.years_studying')]: document.years_studying,
    [this.$i18n.t('result.context.header.document.stay_abroad_months')]: isNil(document.stay_abroad_months) ? 'Unknown' : document.stay_abroad_months
  }, v => v ? v : '')
}
